import {
  UPDATE_USER_INFO,
  UPDATE_USER_TYPE,
  UPDATE_ACCOUNTS,
  UPDATE_ACCESS_TOKEN,
  UPDATE_ACCESS_TOKEN_TYPE,
} from "../mutation-types";
import { APP_KEY } from "src/const/const";

export default {
  namespaced: true,
  state: () => ({
    appKey: APP_KEY,
    userInfo: "",
    userType: "personal",
    accounts: [],
    accessToken: "",
    accessTokenType: "",
  }),
  mutations: {
    // 更新账号列表
    [UPDATE_ACCOUNTS](state, accounts) {
      state.accounts = accounts;
    },
    // 更新用户信息
    [UPDATE_USER_INFO](state, userInfo) {
      state.userInfo = userInfo;
    },
    // 更新用户类型（个人/企业）
    [UPDATE_USER_TYPE](state, userType) {
      state.userType = userType;
    },
    // 更新accessToken
    [UPDATE_ACCESS_TOKEN](state, accessToken) {
      state.accessToken = accessToken;
    },
    // 更新accessToken
    [UPDATE_ACCESS_TOKEN_TYPE](state, accessTokenType) {
      state.accessTokenType = accessTokenType;
    },
  },
};
